require('../../modules/es6.number.parse-int');
module.exports = parseInt;


/*****************
 ** WEBPACK FOOTER
 ** ./~/core-js/library/fn/number/parse-int.js
 ** module id = 737
 ** module chunks = 0
 **/